import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/YoutubeFill.tsx
const YoutubeFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.156 5.897c.317.32.544.716.66 1.151.427 1.605.427 4.952.427 4.952s0 3.347-.427 4.951a2.57 2.57 0 0 1-1.807 1.82c-1.598.429-7.985.429-7.985.429s-6.387 0-7.985-.43a2.568 2.568 0 0 1-1.807-1.819C1.805 15.348 1.805 12 1.805 12s0-3.347.427-4.952A2.569 2.569 0 0 1 4.039 5.23c1.598-.43 7.985-.43 7.985-.43s6.387 0 7.985.43c.434.119.83.35 1.147.668ZM15.276 12 9.934 8.96v6.079l5.342-3.04Z",
		fill: props.fill || "currentColor"
	})
}));
export { YoutubeFillIcon };
